import React from "react";
import { Redirect } from "react-router-dom";

const redirectRoute = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/landing1" />
  }
];

const errorRoute = [
  {
    component: () => <Redirect to="/session" />
  }
];

export const rootRoutes = [
  {
    path: "/landing1",
    component: React.lazy(() => import("./views/Landing1"))
  },
  ...redirectRoute,
  ...errorRoute
];
